import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=4b1a7bc5"
import script from "./CompanyProfile.vue?vue&type=script&lang=js"
export * from "./CompanyProfile.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfile.vue?vue&type=style&index=0&id=4b1a7bc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports